// extracted by mini-css-extract-plugin
export var backdropBlur = "_kt-0";
export var contentCard = "_kt-5";
export var frame = "_kt-2";
export var image = "_kt-4";
export var imagePane = "_kt-3";
export var modal = "_kt-1";